<div class="u-shadow-mini pos-relative">
	<app-loader [showLoader]="showLoad"></app-loader>

	<div class="c-portlet_box_specs sem-calls">
		<div
			class="c-portlet__header o-stack o-stack--center o-stack--splitted u-border-bottom u-px-small u-py-mini c-portlet-gap custom-primary"
		>
			<div class="o-stack__cell">
				<h5 class="calls-title">{{ sectiontitle }}</h5>
				<h4 class="calls-sub-title">Time and Duration of Calls</h4>
				<span *ngIf="hasData">
					<a
						href="javascript:void(0)"
						class="datatable_download_icon"
						(click)="downloadCSVData($event)"
						target="_blank"
					>
						<i class="fa fa-download" aria-hidden="true" *ngIf="!downloadConfiguration.downloadPNGIcon"></i>
						<svg *ngIf="downloadConfiguration.downloadPNGIcon" width="14px" height="17px" viewBox="0 0 14 17">
							<g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
								<path
									d="M14,6 L10,6 L10,0 L4,0 L4,6 L0,6 L7,13 L14,6 Z M0,15 L0,17 L14,17 L14,15 L0,15 Z"
									class="downloadSvgIcon"
									fill-rule="nonzero"
								></path>
							</g>
						</svg>
					</a>
				</span>
			</div>
		</div>
		<div *ngIf="!hasData" class="no-data-min-ht">
			<div>No Data Found</div>
		</div>
		<div *ngIf="hasData" class="analytics-portlet-content">
			<div class="graph-title">
				<div class="graph-filter">
					<div class="filterLabel" [ngClass]="{ 'answered-inactive': graphFilterDisabled }">
						<span>Filter Answered Calls:</span>
					</div>
					<div [ngClass]="{ 'graph-filter-option primary-color': true, 'answered-inactive': graphFilterDisabled }">
						<ng-container *ngIf="!isR104">
							<div *ngFor="let graphFilterOption of graphFilterOptions">
								<label class="container">
									<input
										type="radio"
										name="graphFilterOption"
										value="{{ graphFilterOption.id }}"
										[(ngModel)]="selectedValue"
										(change)="filterChange($event)"
										[disabled]="graphFilterDisabled"
									/>
									<span
										[ngClass]="[
											'radio-option-text',
											graphFilterDisabled ? 'answered-inactive' : '',
											selectedValue == graphFilterOption.id ? 'primary-color' : 'unselected-radio'
										]"
										>{{ graphFilterOption.name }}</span
									>
									<span
										[ngStyle]="{
											'background-color':
												!graphFilterDisabled && selectedValue == graphFilterOption.id ? getColorWithOpactity(0.65) : ''
										}"
										[ngClass]="['radiocheck', 'primary-color-border', graphFilterDisabled ? 'answered-inactive' : '']"
									></span>
								</label>
							</div>
						</ng-container>
						<ng-container *ngIf="isR104">
							<div *ngFor="let graphFilterOption of graphFilterOptionsR104">
								<label class="container">
									<input
										type="radio"
										name="graphFilterOption"
										value="{{ graphFilterOption.id }}"
										[(ngModel)]="selectedValue"
										(change)="filterChange($event)"
										[disabled]="graphFilterDisabled"
									/>
									<span
										[ngClass]="[
											'radio-option-text',
											graphFilterDisabled ? 'answered-inactive' : '',
											selectedValue == graphFilterOption.id ? 'primary-color' : 'unselected-radio'
										]"
										>{{ graphFilterOption.name }}</span
									>
									<span
										[ngStyle]="{
											'background-color':
												!graphFilterDisabled && selectedValue == graphFilterOption.id ? getColorWithOpactity(0.65) : ''
										}"
										[ngClass]="['radiocheck', 'primary-color-border', graphFilterDisabled ? 'answered-inactive' : '']"
									></span>
								</label>
							</div>
						</ng-container>
					</div>
				</div>
				<div class="calls-data" [ngClass]="metricsData ? 'noCalls-div' : ''">
					<div class="call-metrics primary-color">
						<div class="item">
							<div class="data">{{ metricsData.answeredCalls | number }}</div>
							<div class="table-text">Total Answered Calls</div>
						</div>
						<div class="item">
							<div class="data">{{ metricsData.avgDuration }}</div>
							<div class="table-text">Avg. Duration (HH:MM:SS)</div>
						</div>
						<div class="item">
							<div class="data">{{ metricsData.missedCalls | number }}</div>
							<div *ngIf="!isR104" class="table-text">Total Missed Calls</div>
							<div *ngIf="isR104" class="table-text">Missed Calls</div>
						</div>
					</div>
				</div>
			</div>
			<div class="calls-graph-area">
				<div id="chart" #graphArea></div>
			</div>
		</div>
	</div>
</div>
